import { Button } from "react-bootstrap";

function BtnSingle() {
  return (
    <>
        <div className="card-body">
            <h4 className="card-title">Single color buttons</h4>
            <p className="card-description">Add class <code>.btn-&#123;color&#125;</code> for buttons in theme colors</p>
            <div className="template-demo">
                <Button variant="primary btn-fw">Primary</Button>
                <Button variant="secondary btn-fw">Secondary</Button>
                <Button variant="success btn-fw">Success</Button>
                <Button variant="danger btn-fw">Danger</Button>
                <Button variant="warning btn-fw">Warning</Button>
                <Button variant="info btn-fw">Info</Button>
                <Button variant="light btn-fw">Light</Button>
                <Button variant="dark btn-fw">Dark</Button>
                <Button variant="link btn-fw">Link</Button>
            </div>
        </div>
    </>
  )
}

export default BtnSingle